<app-spinner *ngIf="showSpinner$ | async"></app-spinner>
<router-outlet></router-outlet>
